import "./CalendarPicker.sass";

export default {
  name: "eo-calendar-picker",
  props: {
    firstDayOfWeek: {
      // not solved via vuex since we want it independent from vuex
      type: Number,
      default: 1
    },
    id: {
      type: String,
      default: "defaultPickerId"
    }
  },
  data: () => ({
    dates: [
      // holds actual dates
      "",
      ""
    ],
    isDatePickerOpen: false
  }),
  computed: {
    dateRangeText() {
      if (this.$store.state.start && this.$store.state.end) {
        if (this.$store.state.start === this.$store.state.end) {
          return this.formatDate(this.$store.state.start);
        }

        return (
          this.formatDate(this.$store.state.start) +
          " – " +
          this.formatDate(this.$store.state.end)
        );
      }
      return "";
    }
  },
  created() {
    window.addEventListener("resize", this.calculateMenuPosition);
    this.calculateMenuPosition();
  },
  destroyed() {
    window.removeEventListener("resize", this.calculateMenuPosition);
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      // return language formatted date
      return this.$i18n.t("message.dateFormat", [day, month, year]);
    },
    setDates(from, to) {
      this.dates = [from, to];
      // save to store
      this.$store.commit("setStartEnd", {
        start: this.dates[0],
        end: this.dates[1]
      });
      // emit event
      this.$emit("loadData");
    },
    setDateToday() {
      this.isDatePickerOpen = false;
      const calcDate = new Date();
      calcDate.setMinutes(calcDate.getMinutes() - calcDate.getTimezoneOffset()); // remove tz offset
      const date = calcDate.toISOString().substring(0, 10);
      this.setDates(date, date);
    },
    setDateTomorrow() {
      this.isDatePickerOpen = false;
      const calcDate = new Date();
      calcDate.setMinutes(calcDate.getMinutes() - calcDate.getTimezoneOffset()); // remove tz offset
      // add one day
      calcDate.setDate(calcDate.getDate() + 1);
      const date = calcDate.toISOString().substring(0, 10);
      this.setDates(date, date);
    },
    setDateWeekend() {
      this.isDatePickerOpen = false;
      const calcDate = new Date();
      calcDate.setMinutes(calcDate.getMinutes() - calcDate.getTimezoneOffset()); // remove tz offset
      const diffToFriday = 5 - calcDate.getDay();
      switch (diffToFriday) {
        case 5: // Sunday - to last friday
          calcDate.setDate(calcDate.getDate() - 2);
          break;
        default:
          calcDate.setDate(calcDate.getDate() + diffToFriday);
      }
      const date = calcDate.toISOString().substring(0, 10);
      // to sunday
      calcDate.setDate(calcDate.getDate() + 2);
      const sunday = calcDate.toISOString().substring(0, 10);
      this.setDates(date, sunday);
    },
    clearDates() {
      this.isDatePickerOpen = false;
      this.setDates("", "");
    },
    closeOnSecondPick() {
      if (this.dates[0] && this.dates[1]) {
        this.isDatePickerOpen = false;
        this.setDates(this.dates[0], this.dates[1]);
      }
    },
    calculateMenuPosition() {
      setTimeout(() => {
        const menu = document.querySelector(".menu_content__wrapper");
        const calendarPickerActivatorButton = document.querySelector(
          "#calendar_picker__activator_button"
        );
        const widget = document.querySelector(".content-main");
        const { top, left, height } =
          calendarPickerActivatorButton?.getBoundingClientRect() ?? {};

        const { top: widgetTop } = widget?.getBoundingClientRect() ?? {};

        if (menu && left) {
          menu.style.left = `${left}px`;
        }
        if (menu && top && widgetTop)
          menu.style.top = `${top - widgetTop + height}px`;
      }, 100);
    }
  }
};
